import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  CardHeader, Row,
  Col, Card, CardBody
} from "reactstrap";
import { reduxForm } from 'redux-form'
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import 'react-datepicker/dist/react-datepicker.css';
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { validatePassword } from '../../../lib/validation'
import UserAdTypes from './constants'
import * as common from "../../../lib/common"

class AddUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isRequesting: false,
      messages: [],
      errors: [],
      isChecked: false,
    };
  }

  submit = () => {
    const values = this.props.data

    if (this.formValid(values)) {
      var user = {
        TenCongTy: values.TenCongTy.trim() || '',
        DiaChi: values.DiaChi,
        DienThoai: values.DienThoai,
        UserPrefix: values.UserPrefix,
        username: values.username,
        password: values.password,
        UserConnect: values.UserConnect,
        PasswordConnect: values.PasswordConnect,
        LimitUser: values.LimitUser ,
        LinkToQLThuoc: values.LinkToQLThuoc || false,
      }
      this.props.addUser(user);
    }
  }

  formValid = (values) => {
    let ok = true
    this.props.resetError()
    if (!values.TenCongTy || values.TenCongTy.trim() == "") {
      this.props.adminUserSetErrors('Chưa nhập tên công ty')
      ok = false
    }
    if (!values.password) {
      this.props.adminUserSetErrors('Nhập mật khẩu')
      ok = false
    }
    if (values.password) {
      let msg = validatePassword(values.password);
      if (msg) {
        this.props.adminUserSetErrors(msg)
        ok = false
      }
    }
    if (values.PasswordConnect) {
      let msg = validatePassword(values.PasswordConnect);
      if (msg) {
        this.props.adminUserSetErrors(msg)
        ok = false
      }
    }

    if (!values.username) {
      this.props.adminUserSetErrors('Chưa nhập tài khoản')
      ok = false
    }

    if (!values.DienThoai) {
      this.props.adminUserSetErrors('Chưa nhập điện thoại')
      ok = false
    }

    if (!values.DiaChi) {
      this.props.adminUserSetErrors('Chưa nhập địa chỉ')
      ok = false
    }
    return ok
  }
  handleInputChange = (e) => {
    const name = e.target.name
    let value = undefined
    switch (name) {
      case "username":
        value = common.removeUnicode(e.target.value)
        break;
      case "password":
        value = common.removeUnicode(e.target.value)
        break;
      case "UserPrefix":
        value = common.removeUnicode(e.target.value)
        break;
      case "TenCongTy":
        value = e.target.value;
        break;
      case "DienThoai":
        value = e.target.value;
        break;
      case "DiaChi":
        value = e.target.value;
        break;
      case "UserConnect":
        value = e.target.value;
        break;
      case "PasswordConnect":
        value = e.target.value;
        break;
      case "LimitUser":
        value = e.target.value;
        break;
      case "LinkToQLThuoc":
        value = !this.state.isChecked ;
        this.setState({
          isChecked: value,
        });
        break;
    }
    this.setData(name, value);

  }
  setData = (name, value) => {
    let data = {};

    data[name] = value;

    this.props.adminUserSetDataForUser(data);
    this.props.adminUserSetErrors("");

  }

  onClose = (e) => {
    this.props.onClose(this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.parentProps.userAdList.type == UserAdTypes.ITEM_ADD_SUCCESS) {
      setTimeout(() => {
        this.props.fetchList();
        this.onClose();
      }, 2000)
    }
  }

  render() {
    const {
      data,
      requesting,
      messages,
      errors,
    } = this.props
    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isAdding} className="modal-lg" contentClassName="modal-content-fit-height" modalClassName={"modal-fit admin-user"}>
          <ModalHeader>Khởi tạo dữ liệu</ModalHeader>
          <ModalBody>
            <div className="col-sm-12 pl-0 pr-0 mb-2">
              <div className="col-sm-12">Chú ý tắt unikey, vietkey khi gõ Tài khoản, Mật khẩu</div>
            </div>
            <BlockUi tag="div" blocking={requesting}>
              <Card>
                <CardHeader>
                  <i className="fa fa-user-circle-o"></i>Thông tin công ty
                </CardHeader>
                <CardBody className="card-body p-1">
                  <div className="col-sm-12 pl-0 pr-0">
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="TenCongTy">Tên công ty(*)</span>
                      </div>
                      <input name="TenCongTy" type="text" className="form-control display-table-cell" value={data.TenCongTy || ''}
                             aria-describedby="TenCongTy" onChange={e => this.handleInputChange(e)} autoComplete="off" />
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="DienThoai">Điện thoại (*)</span>
                      </div>
                      <input maxLength={13} name="DienThoai" type="text" className="form-control display-table-cell" value={data.DienThoai || ''}
                             aria-describedby="DienThoai" onChange={e => this.handleInputChange(e)} autoComplete="off" />
                    </div>
                    <div className="col-sm-6 col-xs-12 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="DiaChi">Địa chỉ (*)</span>
                      </div>
                      <input maxLength={255} name="DiaChi" type="text" className="form-control display-table-cell" value={data.DiaChi || ''}
                             aria-describedby="DiaChi" onChange={e => this.handleInputChange(e)} autoComplete="off" />
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="username">Tài khoản (*)</span>
                      </div>
                      <input name="username" type="text" className="form-control display-table-cell" value={data.username || ''} onChange={e => this.handleInputChange(e)}
                             aria-describedby="username" autoComplete="off" />
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="password">Mật khẩu (*)</span>
                      </div>
                      <input name="password" type="text" className="form-control display-table-cell" value={data.password || ''} onChange={e => this.handleInputChange(e)}
                             aria-describedby="password" autoComplete="off" />
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="username">User prefix</span>
                      </div>
                      <input maxLength={3} name="UserPrefix" type="text" className="form-control display-table-cell" value={data.UserPrefix || ''} onChange={e => this.handleInputChange(e)}
                             aria-describedby="UserPrefix" autoComplete="off" />
                    </div>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <i className="fa fa-key"></i>Cấu hình liên kết
                </CardHeader>
                <CardBody className="card-body p-1">
                  <div className="col-sm-12 pl-0 pr-0">
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="LinkToQLThuoc">Liên kết với QL thuốc 247</span>
                      </div>
                      <label className="input-group-text text-danger display-tabble-cell pl-1" htmlFor="active_account">
                        <Input className="form-checkbox-append ml-0"
                               onChange={e => this.handleInputChange(e)}
                               aria-label="Small"
                               aria-describedby="inputGroup-sizing-sm"
                               type="checkbox" name="LinkToQLThuoc"
                               id="LinkToQLThuoc"
                               defaultChecked={data.LinkToQLThuoc || this.state.isChecked} />
                      </label>
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="LimitUser">số user tối đa</span>
                      </div>
                      <input name="LimitUser" type="number" className="form-control display-table-cell" value={data.LimitUser || ''}
                             aria-describedby="LimitUser" onChange={e => this.handleInputChange(e)} autoComplete="off" />
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="UserConnect">User connect</span>
                      </div>
                      <input name="UserConnect" maxLength={4} type="text" className="form-control display-table-cell" value={data.UserConnect || ''}
                             aria-describedby="UserConnect" onChange={e => this.handleInputChange(e)} autoComplete="off" />
                    </div>
                    <div className="col-sm-6 mb-2 pull-left input-group display-table">
                      <div className="input-group-prepend display-table-cell">
                        <span className="input-group-text" id="PasswordConnect">Password connect</span>
                      </div>
                      <input name="PasswordConnect" type="text" className="form-control display-table-cell" value={data.PasswordConnect || ''}
                             aria-describedby="PasswordConnect" onChange={e => this.handleInputChange(e)} autoComplete="off" />
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="row col-sm-12">
                <div className="col-sm-12 mb-2 pull-left">
                  {!requesting && errors && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!requesting && messages && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </div>
              </div>
              <div className="row col-sm-12">
                <div className="col-sm-12 mb-2 pull-left p-0">
                  <div className="btn-group float-right" role="group">
                    <Button className="mr-1" onClick={e => this.submit()} color="primary" type="submit"><i className="fa fa-floppy-o"></i>&nbsp;Lưu</Button>
                    <Button color="secondary" onClick={e => this.onClose()}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
                  </div>
                </div>
              </div>
            </BlockUi>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

const formed = reduxForm({
  form: 'form-addUser',
})(AddUser)

export default formed;


// WEBPACK FOOTER //
// ./src/views/Admin/UserAd/_AddUser.js